import React from 'react'
// import StoneMain from './StoneMain/StoneMain'
import StoneHorizontalCenters from './StoneHorizontalСenters/StoneHorizontalСenters'
import StoneVertical from './StoneVertical/StoneVertical'
import StoneTables from './StoneTables/StoneTables'
import StoneWaterjet from './StoneWaterjet/StoneWaterjet'
// import NewsPreview from '../../Modules/NewsBlock/NewsPreview'
import HeaderEngineering from '../../Modules/HeaderEngineering/HeaderEngineering'

const Index = () => {
  return (
    <div>
      <HeaderEngineering />
      {/*<StoneMain />*/}
      <StoneHorizontalCenters />
      <StoneVertical />
      <StoneTables />
      <StoneWaterjet />
      {/*<NewsPreview />*/}
    </div>
  )
}

export default Index
